import { MediaTypeEnum } from "../../enums";
import { MediaDto, MediaStatusEnum } from "../../interfaces/media";

export const isSessionRecording = (item: MediaDto): boolean =>
  item.type === MediaTypeEnum.VIDEO && /\.webm$/i.test(item.name || "");

export const recordingSortTime = (item: MediaDto): number => {
  const stamp = (item.name || "").match(/-(\d{13})\.webm$/i);
  if (stamp) return Number(stamp[1]);
  const created = item.createdAt ? new Date(item.createdAt).getTime() : 0;
  return Number.isFinite(created) ? created : 0;
};

export const lectureRecordings = (media?: MediaDto[]): MediaDto[] =>
  (media || [])
    .filter(isSessionRecording)
    .sort((left, right) => recordingSortTime(left) - recordingSortTime(right));

export const isRecordingPending = (item: MediaDto): boolean =>
  item.status !== MediaStatusEnum.COMPLETED &&
  item.status !== MediaStatusEnum.FAILED;

export const recordingPlayableUrl = (item: MediaDto): string | undefined => {
  if (item.status !== MediaStatusEnum.COMPLETED) return undefined;
  return item.videoUrl || item.path || undefined;
};
